import { QRCodeGenerator } from '@/components/QRCodeGenerator'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import { useState, useEffect } from 'react'
import { LanguageCode, translations } from '@/lib/i18n/translations'
import { detectLanguage } from '@/lib/i18n/utils'
import { Toaster } from 'sonner'
import { PWAPrompt } from '@/components/PWAPrompt'

export default function App() {
  const [language, setLanguage] = useState<LanguageCode>("en")
  const t = translations[language]

  useEffect(() => {
    // Check URL params first, then browser settings
    const params = new URLSearchParams(window.location.search)
    const langParam = params.get('lang') as LanguageCode
    
    if (langParam && Object.keys(translations).includes(langParam)) {
      setLanguage(langParam)
    } else {
      setLanguage(detectLanguage())
    }
  }, [])

  useEffect(() => {
    document.documentElement.lang = language
  }, [language])

  const handleLanguageChange = (newLang: LanguageCode) => {
    setLanguage(newLang)
    
    // Update URL without refreshing the page
    const url = new URL(window.location.href)
    url.searchParams.set('lang', newLang)
    window.history.pushState({}, '', url)
  }

  return (
    <>
      <Toaster position="top-right" />
      <PWAPrompt />
      <div className="flex min-h-screen flex-col">
        <Header language={language} onLanguageChange={handleLanguageChange} />
        <main className="mx-auto w-full max-w-[1480px] flex-1 px-3 py-4 sm:px-6 sm:py-8">
          <QRCodeGenerator t={t} />
        </main>
        <Footer />
      </div>
    </>
  )
}
